const superfetch = {
  emptyInput: "This value can't be empty",
  fileTypes: "File types:",
  backEdit: "Back to Edit",
};

export default superfetch;
